import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Outlet, useParams } from "react-router";
import {
  setCampusData,
  setDroneNest,
  setFloors,
} from "../../../../Service/mappers";
import { CheckValue } from "../../../../Service/service"; // Make sure this exists
import { useHeaderContext } from "../../Constant";
import {
  ActiveCampusContextProvider,
  ActiveDroneNestContextProvider,
  ActiveFloorContextProvider,
  sortFloor,
} from "./Constant";
import { getCampusById } from "../../../../Service/Api/campus";
import { useDebouncedApiCall } from "../../../../hooks";
import axios from "axios";
import { updateDoorState } from "../../../../Service/Api/door";

const CampusDetail = () => {
  const { call } = useDebouncedApiCall();
  const cancelTokenSource = useRef(null);
  const { campusId } = useParams();
  const { setShowMenu } = useHeaderContext();
  const [activeCampus, setActiveCampus] = useState(setCampusData({}));
  const [activeDroneNest, setActiveDroneNest] = useState(setDroneNest({}));
  const [activeFloorDroneNest, setActiveFloorDroneNest] = useState([]);
  const [activeFloor, setActiveFloor] = useState(setFloors({}));
  const [action, setAction] = useState({
    type: null,
    scale: 1,
    image: null,
    showOnMap: null,
    isCenter: true,
    isDirty: false,
  });

  const updateDoor = useCallback(
    (id, value) => async (e) => {
      e?.preventDefault?.();
      try {
        cancelTokenSource.current = axios.CancelToken.source();

        const res = await call(() =>
          updateDoorState({
            id,
            state: value,
          }),
        );
        setActiveCampus((prev) => {
          const active = { ...prev };
          active.availableDoors.forEach((el) => {
            if (el.doors.id === id) {
              el.doors.status = value;
            }
          });
          return active;
        });
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Failed to fetch campus details:", error);
        }
      }
    },
    [],
  );

  useEffect(() => {
    setShowMenu(false);
    return () => {
      setShowMenu(true);
    };
  }, [setShowMenu]);
  useEffect(() => {
    if (!activeDroneNest?.id) {
      setAction((prev) => ({ ...prev, isDirty: false }));
    }
  }, [activeDroneNest]);

  useEffect(() => {
    const fetchData = async (id) => {
      try {
        cancelTokenSource.current = axios.CancelToken.source();

        const res = await call(() =>
          getCampusById(id, { cancelToken: cancelTokenSource.current.token }),
        );
        setActiveCampus(res.data);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Failed to fetch campus details:", error);
        }
      }
    };

    if (CheckValue(campusId)) {
      fetchData(campusId);
    }

    return () => {
      if (cancelTokenSource.current) {
        cancelTokenSource.current.cancel("Cancelled due to new request");
      }
    };
  }, [campusId]);

  const value = useMemo(
    () => ({
      activeCampus,
      setActiveCampus,
      updateDoor,
    }),
    [activeCampus],
  );

  const floorValue = useMemo(
    () => ({
      floors: activeCampus?.floors,
      activeFloor,
      setActiveFloor,
      action,
      setAction,
      activeFloorDroneNest,
      setActiveFloorDroneNest,
    }),
    [activeFloor, action, activeFloorDroneNest, activeCampus?.floors],
  );

  const droneNestValue = useMemo(
    () => ({
      droneNests: activeCampus?.drone_nests,
      activeDroneNest,
      setActiveDroneNest,
    }),
    [activeDroneNest, activeCampus?.drone_nests],
  );

  useEffect(() => {
    if (activeCampus?.floors.length) {
      setActiveFloor([...activeCampus?.floors].sort(sortFloor).at(-1));
    }
  }, [activeCampus?.floors]);
  // useEffect(() => {
  //   if (activeCampus?.drone_nests.length) {
  //     setActiveFloor([...activeCampus?.floors].sort(sortFloor).at(-1));
  //   }
  // }, [activeCampus?.floors,activeCampus?.drone_nests]);

  useEffect(() => {
    if (!!activeFloor?.id && activeCampus?.drone_nests.length) {
      setActiveFloorDroneNest(
        [...activeCampus?.drone_nests].filter(
          (el) => el.floor_id === activeFloor?.id,
        ),
      );
    }
  }, [activeCampus?.drone_nests, activeFloor?.id]);

  return (
    <ActiveCampusContextProvider value={value}>
      <ActiveDroneNestContextProvider value={droneNestValue}>
        <ActiveFloorContextProvider value={floorValue}>
          <Outlet />
        </ActiveFloorContextProvider>
      </ActiveDroneNestContextProvider>
    </ActiveCampusContextProvider>
  );
};

export default CampusDetail;
